import React from 'react';
import LockIcon from '@mui/icons-material/Lock';
import ShieldIcon from '@mui/icons-material/Shield';
import { useCountdown } from './useCountdown';
export function PricingCard() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section id="pricing-section" className="py-8 md:py-12 px-4 max-w-3xl mx-auto" data-id="element-191">
      <div className="text-center mb-5" data-id="element-192">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-brand-dark mb-3" data-id="element-193">
          ESTA OFERTA CIERRA EN:
        </h2>
        <div className="flex justify-center gap-2 md:gap-3 mb-3" data-id="element-194">
          <div className="bg-brand-dark text-white rounded-lg p-2 w-16" data-id="element-195">
            <span className="text-xl font-mono font-bold block" data-id="element-196">{hours}</span>
            <span className="text-[10px] text-gray-300" data-id="element-197">hs</span>
          </div>
          <div className="text-xl font-bold text-brand-dark self-center" data-id="element-198">:</div>
          <div className="bg-brand-dark text-white rounded-lg p-2 w-16" data-id="element-199">
            <span className="text-xl font-mono font-bold block" data-id="element-200">{minutes}</span>
            <span className="text-[10px] text-gray-300" data-id="element-201">min</span>
          </div>
          <div className="text-xl font-bold text-brand-dark self-center" data-id="element-202">:</div>
          <div className="bg-brand-dark text-white rounded-lg p-2 w-16" data-id="element-203">
            <span className="text-xl font-mono font-bold block" data-id="element-204">{seconds}</span>
            <span className="text-[10px] text-gray-300" data-id="element-205">seg</span>
          </div>
        </div>
        <p className="text-red-500 font-bold flex items-center justify-center gap-2 text-sm" data-id="element-206">
          ⚠️ Después aumenta de precio.
        </p>
        <p className="text-brand-text mt-2 text-xs md:text-sm max-w-md mx-auto" data-id="element-207">
          🔴 Cada vez más personas descubren el Punch Needle y comienzan a
          vender sus creaciones.
        </p>
      </div>

      <div className="bg-white rounded-2xl shadow-soft border-2 border-brand-pink overflow-hidden relative" data-id="element-208">
        <div className="bg-brand-pink text-white text-center py-1.5 font-bold tracking-wider text-sm" data-id="element-209">
          ⭐ MÁS ELEGIDO
        </div>

        <div className="p-5 md:p-8 text-center" data-id="element-210">
          <h3 className="font-heading text-2xl md:text-3xl font-black text-brand-dark mb-1" data-id="element-211">
            🎨 PACK ARTE BORDADO
          </h3>
          <p className="text-brand-purple font-bold text-base md:text-lg mb-2" data-id="element-212">
            📘 Tomo 1 + 📙 Tomo 2 + 🎁 4 Bonos
          </p>
          <p className="text-brand-text mb-4 text-sm md:text-base" data-id="element-213">
            Ideal para aprender desde cero y crear piezas artesanales
            profesionales.
          </p>

          <div className="mb-5" data-id="element-214">
            <p className="text-gray-400 line-through text-base md:text-lg font-medium mb-0" data-id="element-215">
              $49.999
            </p>
            <div className="flex items-start justify-center text-brand-dark" data-id="element-216">
              <span className="text-2xl font-bold mt-1.5" data-id="element-217">$</span>
              <span className="text-5xl md:text-6xl font-black tracking-tight" data-id="element-218">
                19.999
              </span>
              <span className="text-base font-bold mt-1.5 ml-1" data-id="element-219">ARS</span>
            </div>
          </div>

          <a href="https://pagos.indigo33.shop/cart/63717495505265:1" className="block w-full bg-brand-coral hover:bg-brand-coralHover text-white font-bold text-base md:text-lg py-4 px-6 rounded-xl shadow-glow transition-all transform hover:-translate-y-1 active:translate-y-0 mb-3" data-id="element-220">
            🎨 QUIERO EL PACK ARTE BORDADO
          </a>

          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-5 text-xs md:text-sm text-gray-600 font-medium" data-id="element-221">
            <div className="flex items-center gap-1" data-id="element-222">
              <LockIcon fontSize="small" className="text-green-500" data-id="element-223" /> Pago
              seguro
            </div>
            <div className="flex items-center gap-1" data-id="element-224">
              <span className="text-green-500 text-lg" data-id="element-225">⚡</span> Acceso
              inmediato
            </div>
            <div className="flex items-center gap-1" data-id="element-226">
              <ShieldIcon fontSize="small" className="text-green-500" data-id="element-227" />{' '}
              Garantía 7 días
            </div>
          </div>
        </div>
      </div>
    </section>;
}